// extracted by mini-css-extract-plugin
export default {"datePicker":"DatePicker_datePicker__7D8bf","datePickerInput":"DatePicker_datePickerInput__ZtoCK","requiredAsterisk":"DatePicker_requiredAsterisk__Da03Z"};